import YourProjectsRouteLoader from './YourProjectsRouteLoader'
export default YourProjectsRouteLoader
